module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("DREAMS and VISIONS")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "ct1",
    attrs: {
      "id": "p0013-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_c('b')]), _c('b', [_c('a', {
    attrs: {
      "href": "#/chapter2#a_31",
      "id": "b_31"
    }
  }, [_vm._v("PREFACE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "p0013-02-1"
    }
  }, [_c('span', [_vm._v("Jesus and Muslims "), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "p0013-03-2"
    }
  }, [_c('span', {
    staticClass: "dcap3"
  }, [_vm._v("T")]), _c('span', [_vm._v("he world appears to be getting more dangerous by the minute. Sometimes it seems as if the “tares” sown in the Master’s field are taking over."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter42#x_1",
      "id": "y_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Yet there is a God in heaven who still cares about us, still sits on His throne, and still has a plan. And thanks to His revolutionary plan for our world, the wheat is flourishing."), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-04-5"
    }
  }, [_c('span', [_vm._v("The world-shattering tactics of God exhibit an ebb and flow, and church historians have a word for these periods of revolution: "), _c('i', [_vm._v("revivals")]), _vm._v(". In each revival, God moves, Jesus is lifted up, people repent, and cultures are transformed. Nations and continents have been shaken by the power of these fresh works of God, but today’s movement may be the most startling of all time. It will likely have the most far-reaching effect on the world since Jesus first set foot in our dimension more than two thousand years ago. These days, Jesus is introducing Himself to Muslims.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-05-7"
    }
  }, [_c('span', [_vm._v("The phenomenon is not limited to a few isolated locations. It’s not happening in just one or two African nations. There’s not "), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_vm._v(" just one of several hundred people groups affected in India. He’s not simply visiting some lucky town in the Middle East. What we see is Jesus presenting Himself to Muslims everywhere. Dozens of Islamic countries and countless Muslim cultures have been invaded by Jesus’ love.")])])]), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-2"
    }
  }, [_c('span', [_vm._v("If you are concerned about the end of the world or Islamic fundamentalism or whether or not America will survive an economic collapse, this book is for you. Whatever world condition worries you most, you can take heart that Jesus remains firmly in control.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-3"
    }
  }, [_c('span', [_vm._v("As always, Jesus touches people one by one. This book presents a handful of the thousands of personal stories you won’t be hearing on the news. Yet it reveals the most important movement of our time—the movement of God.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-03-5"
    }
  }, [_c('span', [_vm._v("So take a deep breath and enter a new world. Muslims are coming to faith in Jesus all over the globe. Their faith is fresh, and their passion will capture your heart. Your new brothers and sisters in Christ live in Iran, Afghanistan, Egypt, Saudi Arabia, and the Gaza Strip. They make their homes in Syria, Jordan, Iraq, and the West Bank. And everywhere, they are bold and willing to die for Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-03-6"
    }
  }, [_c('span', [_vm._v("Each of their stories is really His story. Jesus wants you to know what He’s doing and to appreciate the power by which He still works today. To us, these dreams and visions are supernatural experiences, but to Jesus, I suspect He’s just doing business here on earth the way He always has. The stories in this book are about real people I know personally or are known by my family’s closest friends in the Middle East. If we couldn’t verify the experience, we left it out—no Christian fairy tales here.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-04-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_c('span', [_vm._v("More Muslims are coming to faith in Jesus today then ever before. In fact, we believe more Muslims have become followers ")])]), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_vm._v(" of Jesus in the last ten years than in the last fourteen centuries of Islam. Could it be that the "), _c('i', [_vm._v("real ")]), _vm._v("story about Muslims today is not global terrorism? Could it be the real story about Muslims is that Jesus is reaching out to them with His offer of eternal life earned by His death on the cross and resurrection from the dead? I believe Islamic terrorism is Satan’s attempt to keep the gospel message away from Muslims. The enemy thinks that if he can make the rest of us afraid of Muslims or make us hate them, then he can short-circuit Jesus’ church from reaching Muslims. But that isn’t working. Jesus has stepped in and is opening Muslim hearts Himself.")])]), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-2"
    }
  }, [_c('span', [_vm._v("In order to protect the courageous believers who are willing to let me share their stories, I’ve changed some names and a few details that could reveal identities and put people in even greater danger than the threats they already face. But make no mistake, these are actual stories of believers on the front lines. You’ll see this is far more exciting than the best fiction. The real stuff God does is much more interesting. So prepare to be amazed. Islam has a visitor. Jesus has arrived.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbaac30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 75
// module chunks = 0